import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  FormFeedback,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

export class DropdownButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }
  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  render() {
    return (
      <ButtonDropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
        className={this.props.className}
        disabled={this.props.disabled}
      >
        {this.props.children}
      </ButtonDropdown>
    );
  }
}

const StaticDropdown = ({ t, data, ...props }) => {
  return (
    <FormGroup className={props.containerClasses}>
      <DropdownButton>
        <DropdownToggle caret color="secondary">
          {t('Actions')}
        </DropdownToggle>
        <DropdownMenu>
          {data.map((d, index) => {
            return (
              <React.Fragment key={index}>
                <DropdownItem
                  style={{ boxSizing: 'border-box' }}
                  onClick={d.action}
                  disabled={d.disabled}
                >
                  {t(d.label)}
                </DropdownItem>
                {index + 1 < data.length && <DropdownItem divider />}
              </React.Fragment>
            );
          })}
        </DropdownMenu>
      </DropdownButton>
    </FormGroup>
  );
};

const DynamicDropdown = ({
  data = [],
  value,
  valueKey,
  nameKey,
  subtitleKey,
  invalid,
  error,
  t,
  custom = {},
  ...props
}) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const [_value, setValue] = React.useState(value);
  function renderPureArray() {
    return (
      <DropdownMenu>
        {data.map((d, index) => (
          <React.Fragment key={d}>
            <DropdownItem
              value={d}
              style={{ boxSizing: 'border-box' }}
              onClick={() => {
                if (props.onChange) {
                  props.onChange(d);
                }
              }}
            >
              {props.translated ? <p>{t(d)}</p> : <p>{d}</p>}
            </DropdownItem>
            {index + 1 !== data.length && <DropdownItem divider />}
          </React.Fragment>
        ))}
      </DropdownMenu>
    );
  }
  function getText() {
    if (value === null || value === undefined || value === '')
      return props.translate ? t(props.label) : props.label;
    if (!props.includeZero && value === 0)
      return props.translate ? t(props.label) : props.label;
    if (props.pureArray) {
      const _result = data.filter((d) => d === value);
      if (!_result) return '';
      return props.translated ? t(_result) : _result;
    }
    if (Object.keys(custom).length) {
      if (custom.displayFormat) return custom.displayFormat;
    }
    const result = data.filter(
      (d) => d[valueKey].toString() === value.toString(),
    )[0];
    if (!result) return '';
    return props.translated ? t(result[nameKey]) : result[nameKey];
  }
  function renderItem(d) {
    let result;
    if (typeof nameKey === 'string') {
      result = d[nameKey];
    }
    if (Array.isArray(nameKey)) {
      result = `(${d[nameKey[0]] && d[nameKey[0]].trim()}) ${d[nameKey[1]]}`;
    }
    return <p>{props.translated ? t(result) : result}</p>;
  }
  return (
    <FormGroup className={props.containerClasses}>
      {!props.noLabel && (
        <Label className={props.required ? 'required' : ''}>
          {t(props.label)}
        </Label>
      )}
      <ButtonDropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className={props.className}
      >
        <DropdownToggle
          caret
          color={invalid && error ? 'danger' : 'secondary'}
          className={props.dropdownToggleClassName}
          style={props.dropdownToggleStyle}
          disabled={props.disabled}
        >
          {getText()}
        </DropdownToggle>
        {props.pureArray ? (
          renderPureArray()
        ) : (
          <DropdownMenu className="provenance-dropdown-menu">
            {data.map((d, index) => (
              <React.Fragment key={d[valueKey]}>
                <DropdownItem
                  value={`${d[valueKey]}`}
                  style={{ boxSizing: 'border-box' }}
                  onClick={(e) => {
                    e.preventDefault();
                    setValue(d[valueKey]);
                    if (props.onChange) {
                      props.onChange({
                        value: d[valueKey],
                        text: d[nameKey],
                      });
                    }
                  }}
                >
                  {renderItem(d)}
                  {subtitleKey && (
                    <p
                      style={{
                        fontSize: '0.75rem',
                        fontStyle: 'italic',
                      }}
                    >
                      {d[subtitleKey]}
                    </p>
                  )}
                </DropdownItem>
                {index + 1 !== data.length && <DropdownItem divider />}
              </React.Fragment>
            ))}
          </DropdownMenu>
        )}
      </ButtonDropdown>
      {invalid && error && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

const Dropdown = (props) => {
  if (props.type === 'static') {
    return <StaticDropdown {...props} />;
  } else return <DynamicDropdown {...props} />;
};

Dropdown.defaultProps = {
  type: 'dynamic',
  includeZero: false,
};

Dropdown.propTypes = {
  type: PropTypes.oneOf(['static', 'dynamic']).isRequired,
};

export default withTranslation('app')(Dropdown);
